import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Layout from './App';
import Home from './Components/Home';
import Muda from './Components/Muda';
import Ninja from './Components/Ninja';
import Futsch from './Components/Futsch';

import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='muda' element={<Muda />} />
          <Route path='ninja' element={<Ninja />} />
          <Route path='futsch' element={<Futsch />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
